<template>
    <auth-link v-if="url" :to="url" @click.native="action()" class="btn float-button" :class="[sideStyle, colorStyle, levelStyle, optionStyle]" :title="title" :style="'transform: rotate(' + rotateDeg + 'deg)'">
        <i class="material-icons">{{icon}}</i>
    </auth-link>
    <span v-else @click="action()" class="btn float-button" :class="[sideStyle, colorStyle, levelStyle, optionStyle]" :title="title" :style="'transform: rotate(' + rotateDeg + 'deg)'">
        <i class="material-icons">{{icon}}</i>
    </span>
</template>

<script>

export default {
    props: ['side', 'icon', 'title', 'url', 'color', 'level', 'rotate', 'option'],
    data() {
        return {
            rotateDeg: 0
        }
    },
    computed: {
        sideStyle() {
            if (!this.option) return "float-button-" + this.side;
        },
        colorStyle() {
            if(this.color)
                return "float-button-" + this.color;
            return "float-button-default";
        },
        levelStyle() {
            if (this.option) return;
            if(this.level)
                return "float-button-level-" + this.level;
            return "float-button-level-0";
        },
        optionStyle() {
            if (this.option) return 'option';
        }
    },
    methods: {
        action() {
            if(this.rotate)
                this.rotateDeg += this.rotateDeg == 0 ? 120 : -120;
            if(!this.url)
                this.$emit('action');
        }
    }
}
</script>

<style scoped>
    .float-button {
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        height: 48px;
        width: 48px;
        z-index: 1;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
        transition: 500ms;
    	cursor: pointer;
    }

    .option {
        position: unset;
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .float-button-level-0 {
        bottom: 25px;
    }    

    .float-button-level-1 {
        bottom: 70px;
    }    

    .float-button-level-2 {
        bottom: 125px;
    }    

    .float-button-level-3 {
        bottom: 180px;
    }    

    .float-button-default {
        background-color: #0AC6B7 !important;
        border-color: #02BDA8 !important;        
    }

    .float-button-purple {
        background-color: #47276B !important;
        border-color: #40385C !important;        
    }

    .float-button-light-purple {
        background-color: #8768AB !important;
        border-color: #80799C !important;        
    }    

    .float-button-save {
        background-color: #163247 !important;
        border-color: #042035 !important;        
    }        

    .float-button-disable {
        background-color: #8e9294 !important;
        border-color: #949798 !important;        
    }     

    .float-button-right {
        left: 95%
    }

    .float-button-left {
        left: 1%
    }    

    .float-button i {
        color: #FFF;
        vertical-align: -webkit-baseline-middle;
        transition-duration: 1s;
    }  

    .float-button:hover i {
        font-weight: bold;
    }           
</style>



// WEBPACK FOOTER //
// src/components/shared/FloatButton.vue